"use strict";
/**
 * Weekly Report V2 Enums
 *
 * Enums for the V2 weekly report generation pipeline.
 * Covers report lifecycle, evaluations, narrative state, and progressive profiling.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.profilingQuestionTypeEnum = exports.ProfilingQuestionType = exports.wrEvaluationTypeEnum = exports.WREvaluationType = exports.contentSourceEnum = exports.ContentSource = exports.reportSectionEnum = exports.ReportSection = exports.weeklyReportSkipReasonEnum = exports.WeeklyReportSkipReason = exports.weeklyReportStatusEnum = exports.WeeklyReportStatus = exports.reportVariantEnum = exports.ReportVariant = exports.reportModeEnum = exports.ReportMode = void 0;
// ============================================================================
// REPORT MODE
// ============================================================================
/**
 * Report mode determines the content framing.
 * - first_report: Generated when user accumulates 3 unique scan days
 * - rolling: Generated every Sunday after the first report
 */
exports.ReportMode = {
    FIRST_REPORT: 'first_report',
    ROLLING: 'rolling',
};
exports.reportModeEnum = Object.values(exports.ReportMode);
// ============================================================================
// REPORT VARIANT
// ============================================================================
/**
 * Report variant determines content depth.
 * - rich: User scanned this week. Full content + LLM narrative.
 * - medium: Evaluation phase boundary but no new scan. Moderate content.
 * - light: No new data. Minimal content.
 */
exports.ReportVariant = {
    RICH: 'rich',
    MEDIUM: 'medium',
    LIGHT: 'light',
};
exports.reportVariantEnum = Object.values(exports.ReportVariant);
// ============================================================================
// WEEKLY REPORT STATUS
// ============================================================================
/**
 * Weekly report generation lifecycle status.
 * Simplified from V1's 8-status pipeline to 4 states.
 */
exports.WeeklyReportStatus = {
    PENDING: 'pending',
    GENERATING: 'generating',
    READY: 'ready',
    FAILED: 'failed',
    SKIPPED: 'skipped',
};
exports.weeklyReportStatusEnum = Object.values(exports.WeeklyReportStatus);
// ============================================================================
// WEEKLY REPORT SKIP REASON
// ============================================================================
/**
 * Why a weekly report row exists with status `skipped` rather than `ready`.
 * `subscription_required` → generation was gated by the paywall; the frontend
 * renders a Subscribe state instead of report content.
 */
exports.WeeklyReportSkipReason = {
    SUBSCRIPTION_REQUIRED: 'subscription_required',
};
exports.weeklyReportSkipReasonEnum = Object.values(exports.WeeklyReportSkipReason);
// ============================================================================
// REPORT SECTION
// ============================================================================
/**
 * The 8 sections of a V2 weekly report.
 * Hard cutover from V1's 10 sections.
 */
exports.ReportSection = {
    COVER: 'cover',
    SKIN_SNAPSHOT: 'skin_snapshot',
    APPARENT_AGE: 'apparent_age',
    NOTABLE_CHANGES: 'notable_changes',
    ROUTINE: 'routine',
    SUGGESTIONS: 'suggestions',
    DATA_QUALITY: 'data_quality',
    CONTEXT: 'context',
    LIFESTYLE_INSIGHTS: 'lifestyle_insights',
    CLOSE: 'close',
};
exports.reportSectionEnum = Object.values(exports.ReportSection);
// ============================================================================
// CONTENT SOURCE
// ============================================================================
/**
 * How section content was generated.
 * - template: Deterministic template with computed data slots
 * - llm: LLM-generated natural narrative
 * - hybrid: Template structure with LLM-filled slots
 */
exports.ContentSource = {
    TEMPLATE: 'template',
    LLM: 'llm',
    HYBRID: 'hybrid',
};
exports.contentSourceEnum = Object.values(exports.ContentSource);
// ============================================================================
// EVALUATION TYPE
// ============================================================================
/**
 * The type of change being evaluated.
 * Each evaluation tracks a single change to the user's routine.
 */
exports.WREvaluationType = {
    PRODUCT_ADDITION: 'product_addition',
    FREQUENCY_CHANGE: 'frequency_change',
    PRODUCT_REMOVAL: 'product_removal',
    TREATMENT: 'treatment',
};
exports.wrEvaluationTypeEnum = Object.values(exports.WREvaluationType);
// Note: EvaluationPhase, WeeklyEvaluationStatus, and ConclusionDirection
// enums were dropped in V2 (tables deleted). PG enums will be dropped in migration.
// ============================================================================
// PROFILING QUESTION TYPE
// ============================================================================
/**
 * Types of progressive profiling questions asked within reports.
 * Replaces the V1 upfront wizard with contextual in-report questions.
 */
exports.ProfilingQuestionType = {
    ADHERENCE: 'adherence',
    SIDE_EFFECTS: 'side_effects',
    LIFESTYLE: 'lifestyle',
    CONFIRMATION: 'confirmation',
    CONTEXT: 'context',
};
exports.profilingQuestionTypeEnum = Object.values(exports.ProfilingQuestionType);
//# sourceMappingURL=enums.js.map